import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SaveFeedbackService } from './save-feedback.service';

/**
 * Renders {@link SaveFeedbackService} toasts, fixed bottom-right, above every
 * page. Mounted ONCE in `layout.component.html`. Success toasts auto-dismiss
 * (service-driven); every toast also has a manual close. Bootstrap toast
 * markup, matching the Skote template's styling.
 */
@Component({
  selector: 'app-save-feedback',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 1090;" aria-live="polite" aria-atomic="true">
      @for (t of feedback.toasts(); track t.id) {
        <div class="toast show align-items-center text-white border-0 mb-2"
             [class.bg-success]="t.kind === 'success'"
             [class.bg-danger]="t.kind === 'error'"
             role="alert">
          <div class="d-flex">
            <div class="toast-body">
              <i class="mdi me-1"
                 [class.mdi-check-circle-outline]="t.kind === 'success'"
                 [class.mdi-alert-circle-outline]="t.kind === 'error'"></i>
              {{ t.text }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto"
                    aria-label="Close" (click)="feedback.dismiss(t.id)"></button>
          </div>
        </div>
      }
    </div>
  `,
})
export class SaveFeedbackComponent {
  readonly feedback = inject(SaveFeedbackService);
}
